import { SpaPagination } from '../components/inventory/spa-pagination.vue';
Vue.component('spa-pagination', SpaPagination);